import { ChimeraMeUser } from '@/models/user/user.model';

import { EVENT_LABELS } from './labels';
import { MixpanelClient } from './mixpanel';
import { TrackCoursesDeleted } from './types';

export type TrackData = TrackCoursesDeleted;

// O Mixpanel vai pelo `mixpanel-browser` (./mixpanel). O Pocket segue só com o perfil
// (`profile` e o `d-profile` que o `identify` atualiza) e não pode tocar no `window.mixpanel`,
// senão o evento sai duas vezes.
const POCKET_OPTIONS = { useMixpanel: false };

export const OPERATION = {
  CREATED: 'Created',
  UPDATED: 'Updated',
  DELETED: 'Deleted',
  CLONED: 'Cloned',
};

class Analytics {
  static identify(data: {
    id: number;
    email: string;
    name: string;
    flags?: { [key: string]: string | boolean };
  }): void {
    const storedProfile = window.POCKET.profile() || {};
    const userProfile = {
      id: storedProfile.id || data.id,
      email: storedProfile.email || data.email,
      name: storedProfile.name || data.name || 'Colaborador do Descomplica',
    };

    const userId = userProfile.id.toString();
    const traits = {
      email: userProfile.email,
      name: userProfile.name,
      $email: userProfile.email,
      ...data.flags,
    };

    window.POCKET.identify(userId, traits, POCKET_OPTIONS);
    MixpanelClient.identify(userId, traits);
  }

  static identifyMe(meUser: ChimeraMeUser | undefined): void {
    if (!meUser) throw new Error('Could not identify user for analytics');

    Analytics.identify({
      id: Number.parseInt(meUser.id, 10),
      name: meUser.name,
      email: meUser.email,
    });
  }

  // Sem `POCKET.track`: aqui ele só servia ao Mixpanel. O Zé Spot do Pocket só aceita os eventos
  // de aula do LMS e o HubSpot não é configurado neste painel.
  static track(eventName: string, props: TrackData | Record<string, unknown> = {}): void {
    MixpanelClient.track(eventName, {
      ...props,
    });
  }

  static getRawUrl(): string {
    const { host, pathname } = window.location;
    return `${host}${pathname}`;
  }

  static trackPageView(): void {
    this.track(EVENT_LABELS.pageViewed, {
      gt_Location: this.getRawUrl(),
    });
  }

  static trackContentChanged(
    entityName: string,
    operation: string,
    contentId: string | undefined,
    contentName: string,
    payload?: string,
  ): void {
    this.track(EVENT_LABELS.contentChanged, {
      entity: entityName,
      operation,
      contentId,
      contentName,
      payload,
      gt_Location: this.getRawUrl(),
    });
  }
}

export default Analytics;
